import { render, staticRenderFns } from "./AlgoliaSidebar.vue?vue&type=template&id=5a8237ee&scoped=true&"
import script from "./AlgoliaSidebar.vue?vue&type=script&lang=js&"
export * from "./AlgoliaSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AlgoliaSidebar.vue?vue&type=style&index=0&id=5a8237ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8237ee",
  null
  
)

export default component.exports